import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';
import { addHttpToUrl, isUrlValid } from '../../../utils/url';
import Icon from '../../../components/Icon';
import messages from './messages';
import './basicInfoStyles.css';

const petersonsSupportUrl =
  'https://petersons-college-profiles.atlassian.net/servicedesk/customer/portals';
const validUrl = isUrlValid(petersonsSupportUrl) ? petersonsSupportUrl : '';

const BasicInfoComponent = () => (
  <div styleName="basicInfoContainer inline">
    <div styleName="basicInfoIcon">
      <Icon name="info circle" size="large" />
    </div>
    <div styleName="basicInfoTextContainer">
      <p>
        <FormattedMessage {...messages.basicInfoHeader} />
      </p>
      <p>
        <FormattedMessage {...messages.basicInfoSubHeader} />
      </p>
      <div styleName="petersonsSupportLink">
        <Link styleName="inline" to={addHttpToUrl(validUrl)} target="_blank">
          <div styleName="petersonsExternalLinkText">
            <FormattedMessage {...messages.basicInfoLinkText} />
            <Icon name="external alternate" size="large" />
          </div>
        </Link>
      </div>
    </div>
  </div>
);

export default BasicInfoComponent;
